export const connexion = [
  /* {
    path: '/esapce/admin-login',
    name: 'espace.admin.login',
    // meta: { auth: true },
    component: () => import("../layouts/LoginLayout.vue"),
  }, */
  {
    path: '/',
    name: 'espace.admin.connexion',
    // meta: { auth: true },
    component: () => import("../layouts/LoginLayout.vue"),
  },
  {
    path: '/forget_password',
    name: 'espace.admin.forget_password',
    // meta: { auth: true },
    component: () => import("../layouts/ForgotPassword.vue"),
  },
  /* {
    path: '/',
    name: 'espace.admin.inscription',
    // meta: { auth: true },
    component: () => import("../layouts/SiginUpLayout.vue"),
  } */
]
